
import { Base } from '../base-component';
import './self-service.component.scss';

export class SelfService extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/self-service/self-service.component.ts